import script from "./AllProjectsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllProjectsPage.vue?vue&type=script&setup=true&lang=ts"

import "./AllProjectsPage.vue?vue&type=style&index=0&id=3dd7daab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dd7daab"]])

export default __exports__